<template>
    <dl
        v-if="specsMap"
    >
        <template
            v-for="spec in specsMap"
            :key="`spec-list-item-${spec}`"
        >
            <dt>
                {{ spec[0] }}
            </dt>
            <dd>
                <ul>
                    <li
                        v-for="item in spec[1]"
                    >
                        {{ item }}
                    </li>
                </ul>
            </dd>
        </template>
    </dl>
    <dl
        v-else
    >
        <dt
            class="font-weight-regular"
        >
            Specifications not available.
        </dt>
        <dd></dd>
    </dl>
</template>

<script lang="ts" setup>
    import type { WatchStopHandle } from 'vue';
    import type {
        ProductAttrsMaps,
        ProductAttrsGroupSpec,
        Sku
    } from '~/types';

    const props = withDefaults(
        defineProps<{
            attrsMaps: ProductAttrsMaps;
            specGroups: ProductAttrsGroupSpec[];
            currentSkuUid?: Nilish<string>;
            skus?: Sku[];
            useAllSkus?: boolean;
        }>(),
        {
            useAllSkus: false
        }
    );

    const productSpecsObj = useProductSpecs();
    const { getSkuByUid } = useSkusUtils();

    const specsMap = ref<Nullable<[string, string[]][]>>(null);
    let unWatchSkuUid: WatchStopHandle;

    if (!props.useAllSkus) {
        unWatchSkuUid = watch(
            () => props.currentSkuUid,
            (newUid, oldUid) => {
                if (props.skus && newUid && newUid !== oldUid) {
                    const currentSku = getSkuByUid(props.skus, newUid);
                    const mapObj = productSpecsObj.processSpecs(
                        props.specGroups,
                        props.attrsMaps,
                        currentSku?.specUids
                    );
                    specsMap.value = mapObj.length ? mapObj : null;
                    return;
                }
                
                specsMap.value = null;
            },
            {
                immediate: true
            }
        );
    } else {
        specsMap.value = productSpecsObj.processSpecs(props.specGroups);
    }

    onBeforeUnmount(() => {
        unWatchSkuUid?.();
    });
</script>

<style lang="scss"></style>
